/* Selecto theme — vanilla JS, no dependencies.
   Cart: Ajax Cart API (/cart/add.js, /cart/change.js, /cart/update.js) + Section Rendering API. */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};
  var DRAWER_SECTION = 'cart-drawer';
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------- overlays */
  var lastFocus = null;

  function lockScroll(lock) { document.body.classList.toggle('has-overlay', lock); }

  function openOverlay(el, focusTarget) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    lockScroll(true);
    window.setTimeout(function () { (focusTarget || el).focus({ preventScroll: true }); }, 50);
  }

  function closeOverlay(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    if (!$('.drawer.is-open, .menu-drawer.is-open')) lockScroll(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ------------------------------------------------------------- cart drawer */
  function drawer() { return $('[data-cart-drawer]'); }

  function openCart() {
    var d = drawer();
    if (!d) return false;
    openOverlay(d, $('[data-drawer-panel]', d));
    return true;
  }

  function closeCart() { closeOverlay(drawer()); }

  function setCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    $$('[data-cart-badge]').forEach(function (el) { el.hidden = Number(count) === 0; });
  }

  function cartSectionIds() {
    var ids = $$('[data-cart]').map(function (el) { return el.getAttribute('data-section-id'); });
    if (ids.indexOf(DRAWER_SECTION) === -1 && drawer()) ids.push(DRAWER_SECTION);
    return ids.filter(function (id, i) { return id && ids.indexOf(id) === i; });
  }

  // Replace each rendered [data-cart] with fresh HTML, animating the free-shipping bar from its old width.
  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var current = $('[data-cart][data-section-id="' + id + '"]');
      if (!current) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-cart]', doc);
      if (!fresh) return;

      var oldFill = $('[data-ship-fill]', current);
      var oldWidth = oldFill ? oldFill.style.width : null;
      current.replaceWith(fresh);

      var newFill = $('[data-ship-fill]', fresh);
      if (newFill && oldWidth !== null) {
        var target = newFill.style.width;
        newFill.style.width = oldWidth;
        void newFill.offsetWidth; // reflow so the transition runs
        window.requestAnimationFrame(function () { newFill.style.width = target; });
      }
      setCount(fresh.getAttribute('data-count'));
    });
  }

  function showCartError(message) {
    $$('[data-cart-error]').forEach(function (el) { el.textContent = message || strings.cartError || ''; });
  }

  function setLoading(on) {
    $$('[data-cart]').forEach(function (el) { el.classList.toggle('is-loading', on); });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function cartRequest(url, body) {
    body.sections = cartSectionIds();
    body.sections_url = window.location.pathname;
    setLoading(true);
    return postJSON(url, body)
      .then(function (data) {
        renderSections(data.sections);
        if (typeof data.item_count === 'number') setCount(data.item_count);
        return data;
      })
      .catch(function (err) {
        showCartError((err && (err.description || err.message)) || strings.cartError);
      })
      .finally(function () { setLoading(false); });
  }

  function changeLine(key, quantity) {
    return cartRequest((routes.cartChange || '/cart/change') + '.js', { id: key, quantity: Math.max(0, quantity) });
  }

  // Apply / remove discount codes. Shopify accepts a comma-separated list.
  function setDiscounts(codes) {
    return cartRequest((routes.cartUpdate || '/cart/update') + '.js', { discount: codes.join(',') });
  }

  function currentCodes() {
    return $$('[data-discount-remove]', drawer() || document).map(function (b) { return b.getAttribute('data-discount-remove'); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    var opener = t.closest('[data-cart-open]');
    if (opener) {
      if (openCart()) e.preventDefault();
      return;
    }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

    var line = t.closest('[data-line-key]');
    if (line) {
      var key = line.getAttribute('data-line-key');
      var qty = Number(line.getAttribute('data-line-qty'));
      var step = Number(line.getAttribute('data-line-step')) || 1;
      if (t.closest('[data-line-inc]')) changeLine(key, qty + step);
      else if (t.closest('[data-line-dec]')) changeLine(key, qty - step);
      else if (t.closest('[data-line-remove]')) changeLine(key, 0);
      return;
    }

    var removeCode = t.closest('[data-discount-remove]');
    if (removeCode) {
      var code = removeCode.getAttribute('data-discount-remove');
      setDiscounts(currentCodes().filter(function (c) { return c !== code; }));
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;

    if (form.matches('[data-discount-form]')) {
      e.preventDefault();
      var code = (form.elements.discount.value || '').trim();
      if (!code) return;
      setDiscounts(currentCodes().concat([code]));
      return;
    }

    if (form.matches('[data-product-form]')) {
      if (!drawer()) return; // no drawer on this page: let the browser post to /cart/add
      e.preventDefault();
      addToCart(form);
    }
  });

  /* ------------------------------------------------------------ add to cart */
  function addToCart(form) {
    var formId = form.getAttribute('id'); // not form.id: the <input name="id"> shadows it
    var submitters = $$('button[type="submit"]', form).concat(formId ? $$('button[form="' + formId + '"]') : []);
    var errorEl = $('[data-product-error]', form.closest('[data-product-section]') || form);
    submitters.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); b.disabled = true; });
    if (errorEl) errorEl.textContent = '';

    var data = new FormData(form);
    data.append('sections', cartSectionIds().join(','));
    data.append('sections_url', window.location.pathname);

    fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok || json.status) throw json;
          return json;
        });
      })
      .then(function (json) {
        renderSections(json.sections);
        openCart();
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || strings.addError;
        if (errorEl) errorEl.textContent = msg;
        else window.alert(msg);
      })
      .finally(function () {
        submitters.forEach(function (b) { b.removeAttribute('aria-disabled'); b.disabled = false; });
      });
  }

  /* ---------------------------------------------------------- pack selector */
  function initPacks(root) {
    $$('[data-pack-form]', root).forEach(function (form) {
      var section = form.closest('[data-product-section]') || document;
      var property = $('[data-pack-property]', form);
      var radios = $$('input[name="quantity"][form="' + form.getAttribute('id') + '"]');

      function update() {
        var checked = radios.filter(function (r) { return r.checked; })[0];
        if (!checked) return;
        var qty = Number(checked.value);
        if (property) {
          property.value = String(qty);
          property.disabled = qty < 2;
        }
        $$('[data-atc-total]', section).forEach(function (el) { el.textContent = checked.getAttribute('data-pack-total'); });
        var label = checked.getAttribute('data-pack-label');
        var short = checked.getAttribute('data-pack-short');
        $$('[data-sticky-label]', section).forEach(function (el) { el.textContent = short ? label + ' · ' + short : label; });
      }

      radios.forEach(function (r) { r.addEventListener('change', update); });
      update();
    });
  }

  /* ------------------------------------------------------------ product media */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var wrap = thumb.closest('[data-product-media]');
    var id = thumb.getAttribute('data-thumb');
    $$('img[data-media-id]', wrap).forEach(function (img) {
      img.classList.toggle('is-hidden', img.getAttribute('data-media-id') !== id);
    });
    $$('[data-thumb]', wrap).forEach(function (b) { b.setAttribute('aria-current', b === thumb ? 'true' : 'false'); });
  });

  // Product detail panels: open cards on desktop, closed accordions on mobile.
  function syncPanels() {
    $$('.details-grid > details.panel').forEach(function (d) {
      if (mobileQuery.matches) d.removeAttribute('open');
      else d.setAttribute('open', '');
    });
  }
  // Keep panels open on desktop even if a summary is activated by keyboard.
  document.addEventListener('toggle', function (e) {
    if (!mobileQuery.matches && e.target.matches && e.target.matches('.details-grid > details.panel') && !e.target.open) {
      e.target.open = true;
    }
  }, true);

  /* ------------------------------------------------------- collection page */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort-select]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  // Category chips are single-select: picking one replaces the active category filter.
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-chip-single]');
    if (!chip) return;
    e.preventDefault();
    var url = new URL(window.location.href);
    var param = chip.getAttribute('data-chip-single');
    url.searchParams.delete(param);
    url.searchParams.set(param, chip.getAttribute('data-chip-value'));
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ------------------------------------------------------ presenter catalog */
  function initCatalog() {
    var root = $('[data-catalog]');
    if (!root) return;
    var items = $$('.catalog__item', root);
    var count = $('[data-catalog-count]', root);

    function apply(cat) {
      var shown = 0;
      items.forEach(function (item) {
        var match = cat === 'all' || item.getAttribute('data-category') === cat;
        item.hidden = !match;
        if (match) shown++;
      });
      $$('[data-catalog-filter]', root).forEach(function (b) {
        var on = b.getAttribute('data-catalog-filter') === cat;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (count) {
        var tpl = count.getAttribute(shown === 1 ? 'data-one' : 'data-other') || '__N__';
        count.textContent = tpl.replace('__N__', shown);
      }
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-catalog-filter]');
      if (b) apply(b.getAttribute('data-catalog-filter'));
    });
    apply('all');
  }

  /* ------------------------------------------------------- menu + search */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) {
      var menu = $('[data-menu-drawer]');
      openOverlay(menu, $('.menu-drawer__panel', menu));
      return;
    }
    if (t.closest('[data-menu-close]')) { closeOverlay($('[data-menu-drawer]')); return; }

    var searchBtn = t.closest('[data-search-open]');
    if (searchBtn) {
      var panel = document.getElementById('SearchPanel');
      if (!panel) { window.location.href = '/search'; return; }
      panel.hidden = !panel.hidden;
      $$('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true'); });
      if (!panel.hidden) {
        if (mobileQuery.matches) window.scrollTo({ top: 0, behavior: 'smooth' });
        var input = $('input[type="search"]', panel);
        if (input) input.focus();
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart();
    closeOverlay($('[data-menu-drawer]'));
    var panel = document.getElementById('SearchPanel');
    if (panel && !panel.hidden) panel.hidden = true;
  });

  /* ------------------------------------------------------------ boot */
  function boot() {
    initPacks(document);
    initCatalog();
    syncPanels();
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncPanels);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-init a section after it's re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    initPacks(e.target);
    initCatalog();
    syncPanels();
  });
})();
